import React from 'react';
import { useTransactionsList } from './presenter';
import { TransactionsListView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';

type Props = {
  navigate: (r: Route) => void;
};

const TransactionsIndexPage: React.FC<Props> = ({ navigate }) => {
  const vm = useTransactionsList();
  return (
    <TransactionsListView
      data={vm.items}
      filteredData={vm.filteredData}
      total={vm.total}
      page={vm.page}
      pageSize={vm.pageSize}
      setPage={vm.setPage}
      setPageSize={vm.setPageSize}
      query={vm.query}
      setQuery={vm.setQuery}
      machines={vm.machines}
      machineFilter={vm.machineFilter}
      setMachineFilter={vm.setMachineFilter}
      dateFrom={vm.dateFrom}
      setDateFrom={vm.setDateFrom}
      dateTo={vm.dateTo}
      setDateTo={vm.setDateTo}
      loading={vm.loading}
      error={vm.error}
      onView={id => navigate({ name: 'transactions/view', params: { id } as any })}
    />
  );
};

export default TransactionsIndexPage;
